import { render, staticRenderFns } from "./SabotageNotif.vue?vue&type=template&id=4621ad2a&"
import script from "./SabotageNotif.vue?vue&type=script&lang=js&"
export * from "./SabotageNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports